export default {
    welcome: 'Welcome to our website',
    loader : 'Loading...',
    site_description : 'Cyberprotection all-in-one',
    wait: 'Please wait...',
    footer: {
        copyright: 'All rights reserved by'
    },
    button: {
        btnTheme: 'Theme',
        lang: {
            EN: "EN",
            FR: "FR"
        },
        dark: 'Dark mode',
        light: 'Light mode',
        loggedin: 'Sign in',
        verify: {
            default: 'Check',
            email: 'Check my email address'
        },
        reset: 'Reset',
        goback: 'Go to the home page',
        upgrade: 'Upgrade'
    },
    Actions: {
        not_defined: 'Aucune action définie pour {act}'
    },
    login: {
        connect: 'Log in!',
        passwd_forgot: 'Forgot your password?',
        redirect: 'Redirecting, please wait...'
    },
    logout: {
        close: 'Logout',
        title: 'We look forward to seeing you again!',
        content: 'You are now successfully logged out.'
    },
    form: {
        required: '{field} required.',
    },
    email: {
        verify: {
            title: 'Activate your account',
            content: 'Enter your email address to receive a verification code and complete the activation of your account.'
        }
    },
    otp: {
        title: 'OTP code verification',
        content: 'A verification code has been sent to {email}.',
        empty: 'Didn\'t receive the email?',
        resend: 'Resend code',
        progress: 'Sending code…',
        wait: 'Please wait another {minutes} minutes before requesting a new code.',
        retry_in: 'New code available in {minutes}m {seconds}s'
    },
    page: {
        failed: {
            not_found: 'Page not found',
            content: 'The page you are looking for cannot be found.'
        }
    },
    access: {
        limited: 'Restricted access',
        upgrade: 'Upgrade to plan to get access to unlimited'
    }
}